/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
const root = (typeof window !== "undefined") ? window : globalThis;

root.toggleLoader = function() {
  $('.circle-loader').toggleClass('load-complete');
  return $('.checkmark').toggle();
};

root.startLoader = function(el) {
  const $el = $(el);
  const $loader = $el.find('.circle-loader');
  $loader.removeClass('load-complete');
  $loader.addClass('active');
  return $loader.show();
};

root.completeLoader = function(el) {
  const $el = $(el);
  return $el.find('.circle-loader').addClass('load-complete');
};
  //setTimeout (->
  //  $el.find('.circle-loader').fadeOut(1000)
  //), 2000

root.failLoader = function(el) {
  const $el = $(el);
  return $el.find('.circle-loader').addClass('load-failed');
};
  //setTimeout (->
  //  $el.find('.circle-loader').fadeOut(1000)
  //), 2000
